var map = {
	"./aral_komfort.svg": 3281,
	"./aral_plus.svg": 3282,
	"./bp_bonus.svg": 3283,
	"./bp_komfort.svg": 3284,
	"./bp_komfort_prepaid.svg": 3285,
	"./bp_plus.svg": 3286,
	"./fuel-card-active.svg": 3287,
	"./fuel-card-inactive.svg": 3288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3280;